import { render, staticRenderFns } from "./PageHighlightBlock.vue?vue&type=template&id=b8bb15a6&"
import script from "./PageHighlightBlock.vue?vue&type=script&lang=js&"
export * from "./PageHighlightBlock.vue?vue&type=script&lang=js&"
import style0 from "./PageHighlightBlock.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VImg,VRow})
